import { render } from "./Manage.vue?vue&type=template&id=3d8bf8a8"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=3d8bf8a8&lang=css"
script.render = render

export default script